import Vue from 'vue';
import VueMeta from 'vue-meta';
import VueRouter from 'vue-router';
import Home from '@/components/home/index';

import store from '../store';

import {
  HOME_PAGE_NAME,
  DASHBOARD_PAGE_NAME,
  MY_CREATIONS_PAGE_NAME,
  OWNED_BLUEPRINTS_PAGE_NAME,
  ASSET_DETAIL_PAGE_NAME,
  MY_OVERVIEW_PAGE_NAME,
  MY_ACCOUNT_PAGE_NAME,
  MY_ACCOUNT_DETAILS_PAGE_NAME,
  MY_SERVERS_PAGE_NAME,
  ALL_SERVERS_PAGE_NAME,
  ALL_MY_GAMES_PAGE_NAME,
  ALL_COMPOSITIONS_PAGE_NAME,
  CREATORS_CLUB_PRIVATE_PAGE_NAME,
  CREATORS_CLUB_PUBLIC_PAGE_NAME,
  JOIN_CREATORS_CLUB_PAGE_NAME,
  MONETIZATION_DETAIL_PAGE_NAME,
  EDIT_ASSET_PAGE_NAME,
  NOT_FOUND_PAGE_NAME,
  REQUEST_CASHBACK_PAGE_NAME,
  // ERROR_PAGE_NAME,
} from '@/router/pageNameConstants.js';

Vue.use(VueRouter, VueMeta);

const routes = [
  {
    path: '/',
    name: HOME_PAGE_NAME,
    component: Home,
    beforeEnter: (to, from, next) => {
      if (store.getters['user/isLogged']) {
        next('/dashboard');
      } else next();
    },
  },
  {
    path: '/dashboard',
    name: DASHBOARD_PAGE_NAME,
    component: () => import('@/components/dashboard/index'),
    meta: { AuthRoute: true },
  },
  {
    path: '/my_creations',
    name: MY_CREATIONS_PAGE_NAME,
    component: () => import('@/components/my_creations/index'),
    meta: { AuthRoute: true },
  },
  {
    path: '/owned_blueprints',
    name: OWNED_BLUEPRINTS_PAGE_NAME,
    component: () => import('@/components/owned_blueprints/index'),
    meta: { AuthRoute: true },
  },
  {
    path: '/asset_detail/:id',
    name: ASSET_DETAIL_PAGE_NAME,
    component: () => import('@/components/common/asset/Asset'),
    meta: { AuthRoute: true },
  },
  {
    path: '/my_overview',
    name: MY_OVERVIEW_PAGE_NAME,
    component: () => import('@/components/my_overview/index'),
    meta: { AuthRoute: true },
  },
  {
    path: '/my_account',
    name: MY_ACCOUNT_PAGE_NAME,
    component: () => import('@/components/my_account/index'),
    meta: { AuthRoute: true },
  },
  {
    path: '/my_account_details',
    name: MY_ACCOUNT_DETAILS_PAGE_NAME,
    component: () => import('@/components/my_account/sections/account_details'),
    meta: { AuthRoute: true },
  },
  {
    path: '/my_servers',
    name: MY_SERVERS_PAGE_NAME,
    component: () => import('@/components/my_servers/index'),
    meta: { AuthRoute: true },
  },
  {
    path: '/all_servers',
    name: ALL_SERVERS_PAGE_NAME,
    component: () => import('@/components/my_servers/sections/AllServersTable'),
    meta: { AuthRoute: true },
  },
  {
    path: '/all_my_games',
    name: ALL_MY_GAMES_PAGE_NAME,
    component: () =>
      import('@/components/my_overview/sections/AllGamesHostedByMe'),
    meta: { AuthRoute: true },
  },
  {
    path: '/all_compositions',
    name: ALL_COMPOSITIONS_PAGE_NAME,
    component: () =>
      import('@/components/my_overview/sections/AllCompositions'),
    meta: { AuthRoute: true },
  },
  // {
  //   path: '/creators_club',
  //   name: CREATORS_CLUB_PRIVATE_PAGE_NAME,
  //   component: () => import('@/components/creators_club/index'),
  //   meta: { AuthRoute: true },
  //   beforeEnter: (to, from, next) => {
  //     if (store.getters['creator/getCreator'] === 'error') {
  //       next('/creators_club_public');
  //     } else next();
  //   },
  // },
  // {
  //   // SMAZAT
  //   path: '/creators_club_public',
  //   name: CREATORS_CLUB_PUBLIC_PAGE_NAME,
  //   component: () => import('@/components/creators_club_public/index'),
  //   meta: { AuthRoute: true },
  // },
  // {
  //     path: '/join_creators_club',
  //     name: JOIN_CREATORS_CLUB_PAGE_NAME,
  //     component: () => import('@/components/join_creators_club/index'),
  // },
  {
    path: '/monetization_detail/:id',
    name: MONETIZATION_DETAIL_PAGE_NAME,
    component: () => import('@/components/monetization_detail/index'),
    meta: { AuthRoute: true },
  },

  {
    path: '/asset_detail/:id/edit',
    name: EDIT_ASSET_PAGE_NAME,
    component: () => import('@/views/CreateOrEditAsset'),
    meta: { AuthRoute: true },
    props: true,
  },
  {
    path: '/request_cashback',
    name: REQUEST_CASHBACK_PAGE_NAME,
    component: () => import('@/components/request_cashback/index'),
    meta: { AuthRoute: true },
  },
  {
    path: '*',
    name: NOT_FOUND_PAGE_NAME,
    component: () => import('@/views/Error'),
    meta: { onlyView: true },
  },
];

// scrollBehavior:
// - only available in html5 history mode
// - defaults to no scroll behavior
// - return false to prevent scroll
const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    // savedPosition is only available for popstate navigations.
    return savedPosition;
  } else if (from.path == to.path) {
    return;
  } else {
    const position = {
      x: 0,
      y: 0,
    };

    // new navigation.
    // scroll to anchor by returning the selector
    if (to.hash) {
      position.selector = to.hash;
    }
    // check if any matched route config has meta that requires scrolling to top
    if (to.matched.some(m => m.meta.scrollToTop)) {
      // cords will be used if no selector is provided,
      // or if the selector didn't match any element.
      position.x = 0;
      position.y = 0;
    }
    // if the returned position is falsy or an empty object,
    // will retain current scroll position.

    if (to.path === '/') {
      // position.y = document.getElementById('assets-main-filter-wrapper').offsetTop - 150;
    }

    return position;
  }
};

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (!store.getters['user/isLogged']) {
    await store.dispatch('user/loadUser');
  }
  await store.dispatch('creator/fetchCreator');
  if (to.meta.AuthRoute) {
    if (!store.getters['user/isLogged']) {
      next('/');
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
